package com.example.positionahead.data

/** Platform-specific base URL for FMP stable API (web uses same-origin proxy). */
expect fun fmpStableBaseUrl(): String

internal fun fmpStableUrl(path: String): String {
    val base = fmpStableBaseUrl().trimEnd('/')
    val segment = path.trimStart('/')
    return "$base/$segment"
}
